import { createClient, type Session } from '@supabase/supabase-js';

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL as string | undefined;

const publishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as
    | string
    | undefined;

export const cloudConfigured = Boolean(
  supabaseUrl &&
  publishableKey,
);

export const supabase = cloudConfigured
  ? createClient(
      supabaseUrl!,
      publishableKey!,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      },
    )
  : null;

export async function getSession(): Promise<Session | null> {
  if (!supabase) return null;

  const {
    data,
    error,
  } =
    await supabase.auth.getSession();

  if (error) {
    throw error;
  }

  return data.session;
}

export async function signIn(
  email: string,
  password: string,
) {
  if (!supabase) {
    return {
      data: {
        user: null,
        session: null,
      },
      error: new Error(
        'Supabase cloud backend sozlanmagan.',
      ),
    };
  }

  return supabase.auth.signInWithPassword({
    email: email.trim().toLowerCase(),
    password,
  });
}

export async function signUp(
  email: string,
  password: string,
  profile: {
    firstName: string;
    lastName: string;
  },
) {
  if (!supabase) {
    return {
      data: {
        user: null,
        session: null,
      },
      error: new Error(
        'Supabase cloud backend sozlanmagan.',
      ),
    };
  }

  const firstName =
    profile.firstName.trim();

  const lastName =
    profile.lastName.trim();

  const fullName =
    [firstName, lastName]
      .filter(Boolean)
      .join(' ')
      .trim();

  return supabase.auth.signUp({
    email:
      email.trim().toLowerCase(),

    password,

    options: {
      data: {
        first_name: firstName,
        last_name: lastName,
        name: fullName,
        full_name: fullName,
      },

      emailRedirectTo:
        `${window.location.origin}/app`,
    },
  });
}

export async function signInWithGoogle() {
  if (!supabase) {
    return {
      data: {
        provider: 'google',
        url: null,
      },
      error: new Error(
        'Supabase cloud backend sozlanmagan.',
      ),
    };
  }

  return supabase.auth.signInWithOAuth({
    provider: 'google',

    options: {
      redirectTo:
        `${window.location.origin}/app`,

      queryParams: {
        access_type: 'offline',
        prompt: 'select_account',
      },
    },
  });
}

export async function signOut() {
  if (!supabase) return;

  await supabase.auth.signOut();

  localStorage.removeItem(
    'ef-telegram-session',
  );
}
